var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.195 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook_1_",
    d: "M32.195,16.17a16.1,16.1,0,1,0-18.612,15.9V20.824H9.495V16.169h4.087V12.625c0-4.034,2.4-6.263,6.081-6.263a24.707,24.707,0,0,1,3.6.315v3.961H21.235a2.327,2.327,0,0,0-2.624,2.514V16.17h4.464l-.714,4.655H18.611V32.073A16.1,16.1,0,0,0,32.195,16.17Z",
    transform: "translate(0 -0.073)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cf072d99f32080cee6fdf550b6991d91.svg";
export { ForwardRef as ReactComponent };